'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_ItemProps = undefined;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var bpfrpt_proptype_ItemProps = {
  tag: _propTypes2.default.any,
  itemRef: _propTypes2.default.func,
  active: _propTypes2.default.bool,
  label: _propTypes2.default.node.isRequired,
  value: _propTypes2.default.any,
  extraLabel: _propTypes2.default.node,
  description: _propTypes2.default.node,
  appearance: _propTypes2.default.oneOf(['row', 'head']),
  icon: _propTypes2.default.string,
  iconAlign: _propTypes2.default.oneOf(['left', 'right']),
  customIcon: _propTypes2.default.any,
  color: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  extraLabelClass: _propTypes2.default.string,
  className: _propTypes2.default.string,
  separated: _propTypes2.default.bool,
  dataId: _propTypes2.default.string,
  breakLabelText: _propTypes2.default.bool
};
exports.bpfrpt_proptype_ItemProps = bpfrpt_proptype_ItemProps;